import { NotFound } from '@pages/not-found'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

const routes = [
	"/",
	"/teacher/:id"
]

export const RedirectsFromLogin = () => {
	return (
		<Routes>
			{routes.map(el => (
				<Route path={el} key={el} element={<Navigate to='/login' />} />
			))}
			<Route path="*" element={<NotFound />}/>
		</Routes>
	)
}
